/**
 * Joins class names, skipping falsy values.
 * joinClassNames('a', isActive && 'b') -> 'a b' or 'a'
 */
export function joinClassNames(...classNames) {
  return classNames.filter(Boolean).join(' ');
}
